import { taskServices } from "../../Services/TaskServices/task.services";


const taskListing = async (param) => {
    let response = await taskServices.taskListing(param);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const taskCreate = async (data) => {
    let post = {
        assign_to: data && data.assignTo ? data.assignTo : [],
        title: data && data.title ? data.title : null,
        description: data && data.description ? data.description : null,
        priority: data && data.priority ? data.priority : null,
        case_id: data && data.caseData && data.caseData.id ? data.caseData.id : null,
        hospital_id: data && data.patientData && data.patientData.hospitalId ? data.patientData.hospitalId : null,
        patient_id: data && data.patientData && data.patientData.patientId ? data.patientData.patientId : null,
        patient_name: data && data.patientData && data.patientData.patientName ? data.patientData.patientName : null,
        start_date: data && data.startDate ? data.startDate : null,
        end_date: data && data.startDate ? data.startDate : null,                 //<----------end date as start date Added by backend team
        start_time: data && data.startTime ? data.startTime : null,
        end_time: data && data.endTime ? data.endTime : null,
    }
    let response = await taskServices.taskCreate(post);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const taskDetail = async (id) => {
    let response = await taskServices.taskDetail(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const taskUpdate = async (data, id) => {
    let post = {
        assign_to: data && data.assignTo ? data.assignTo : [],
        title: data && data.title ? data.title : null,
        description: data && data.description ? data.description : null,
        priority: data && data.priority ? data.priority : null,
        case_id: data && data.caseId ? data.caseId : null,
        hospital_id: data && data.hospitalId ? data.hospitalId : null,
        patient_id: data && data.patientId ? data.patientId : null,
        patient_name: data && data.patientName ? data.patientName : null,
        start_date: data && data.startDate ? data.startDate : null,
        end_date: data && data.startDate ? data.startDate : null,
        start_time: data && data.startTime ? data.startTime : null,
        end_time: data && data.endTime ? data.endTime : null,
    }
    let response = await taskServices.taskUpdate(post, id);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const taskDelete = async (id) => {
    let response = await taskServices.taskDelete(id);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const taskComplete = async (id) => {
    let response = await taskServices.taskComplete(id);
    if (response) {
        return response;
    } else {
        return null;
    }
};


const taskController = {
    taskListing,
    taskCreate,
    taskDetail,
    taskUpdate,
    taskDelete,
    taskComplete,
};

export default taskController;
